import { render } from "./eventLeague.vue?vue&type=template&id=93add288"
import script from "./eventLeague.vue?vue&type=script&lang=js"
export * from "./eventLeague.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__